module.exports = __webpack_public_path__ + "img/ig-logo.b0f52547.svg";